import React from 'react';

import FormElementContainer from '../FormElement/FormElementContainer';
import { formElemHasError } from '../helpers/getClassName';

function Select({ containerProps={}, label, errors={}, inputName, selectProps, children, showErrorMessageBelow }) {
  const hasError = formElemHasError(inputName, errors);

  return (
    <FormElementContainer
      hideWarningLabelOnFormElement
      {...{
        containerProps,
        label,
        errors,
        inputName,
        showErrorMessageBelow
      }}
    >
      <select
        {...selectProps}
        className={selectProps?.className ? selectProps.className : 'form-elem form-select'}
        aria-invalid={hasError ? "true" : "false"}
      >
        { children }
      </select>
    </FormElementContainer>
  )
}

export default Select;